import { Constant } from "../../utils/constant"

export const userOptionStyle = {
    width: '80%',
    height: '50px',
    border: 'solid black 1px',
    background: Constant.darkBackgroundColor,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
}

export const groupMembersSectionStyle = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
}

export const groupMembersStyle = {
    width: '100%',
    height: '15vw',
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center"
}

export const groupExpenseStyle = {
    width: '100%',
    height: '12vw',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '28px'
}

export const navIconStyle = {
    fontSize: '10vw',
    border: 'solid white 1px',
    borderRadius: '50%',
    padding: '2vw',
    margin: '10px'
}